// extracted by mini-css-extract-plugin
export default {"headerWrapper":"styles_headerWrapper__MywaX","item":"styles_item__83iXN","specialty":"styles_specialty__g8ikR","trade":"styles_trade__XQZxC"};